import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PasswordResetInfoService {
  private readonly _info = signal<{
    username: string | null;
    address?: string | null;
  }>({
    username: null,
    address: null,
  });
  readonly info = this._info.asReadonly();

  set(username: string, address?: string): void {
    this._info.set({ username, address });
  }
}
